import type {TStore} from "modules/types/store";

export const getEntryPointState = (store: TStore) => store.platform.entryDataState;
export const getIsNative = (store: TStore) => store.platform.isNative;
